//=============================================================================
// Attention! This file is generated
//   by /home/timstraube/Programme/Spinnax/freak/freak/freak_tools/src/freak_tools/_com.py
// Only edit within the protected regions!
//=============================================================================

/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/no-unused-vars */

//-----------------------------------------------------------------------------
import * as _Ts from './Com_types';
import * as _Cs from './Com_constants';

// PR_BEG user_imports
// PR_END

//-----------------------------------------------------------------------------
function packetIdOfArrayBuffer( buffer: ArrayBuffer ): number {
    const dataView = new DataView(buffer);
    const id = dataView.getUint8(0);
    return id;
}

//-----------------------------------------------------------------------------
export function packetIdToName(id: number): string {
    if(id === null) {
        return "NAME_OF_NONE_PACKET_ID";
    }
    else if( id === 7 ) {
        return "PckCmdIdBeg";
    }
    
    else if( id === 36 ) {
        return "PckCmdReBeg";
    }
    
    else if( id === 11 ) {
        return "PckCmdPlBeg";
    }
    
    else if( id === 13 ) {
        return "PckCmdMaBeg";
    }
    
    else if( id === 15 ) {
        return "PckCmdCalibrate";
    }
    
    else if( id === 17 ) {
        return "PckCmdTare";
    }
    
    else if( id === 4 ) {
        return "PckCmdReTrgDPS310";
    }
    
    else if( id === 32 ) {
        return "PckCmdReTrgBNO08X";
    }
    
    else if( id === 30 ) {
        return "PckCmdReTrg";
    }
    
    else if( id === 22 ) {
        return "PckCmdLog";
    }
    
    else if( id === 23 ) {
        return "PckCmdInfo";
    }
    
    else if( id === 24 ) {
        return "PckCmdReset";
    }
    
    else if( id === 26 ) {
        return "PckCmdResetBNO08X";
    }
    
    else if( id === 28 ) {
        return "PckCmdResetDPS310";
    }
    
    else if( id === 8 ) {
        return "PckRspIdBeg";
    }
    
    else if( id === 37 ) {
        return "PckRspReBeg";
    }
    
    else if( id === 12 ) {
        return "PckRspPlBeg";
    }
    
    else if( id === 14 ) {
        return "PckRspMaBeg";
    }
    
    else if( id === 16 ) {
        return "PckRspCalibrate";
    }
    
    else if( id === 18 ) {
        return "PckRspTare";
    }
    
    else if( id === 19 ) {
        return "PckRspReTrgDPS310";
    }
    
    else if( id === 33 ) {
        return "PckRspReTrgBNO08X";
    }
    
    else if( id === 31 ) {
        return "PckRspReTrg";
    }
    
    else if( id === 3 ) {
        return "PckRspLog";
    }
    
    else if( id === 6 ) {
        return "PckRspInfo";
    }
    
    else if( id === 25 ) {
        return "PckRspReset";
    }
    
    else if( id === 27 ) {
        return "PckRspResetBNO08X";
    }
    
    else if( id === 29 ) {
        return "PckRspResetDPS310";
    }
    
    return "NAME_OF_UNKNOWN_PACKET_ID";
}

//-----------------------------------------------------------------------------
export class PckCmdIdBeg {

    public static ID = 7;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckCmdIdBeg_constructor
        // PR_END
        this.header.packet_id = PckCmdIdBeg.ID;
    }

    // PR_BEG PckCmdIdBeg_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckCmdIdBeg: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckCmdIdBeg | null {
        if( packetIdOfArrayBuffer( buffer ) != PckCmdIdBeg.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckCmdIdBeg();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckCmdReBeg {

    public static ID = 36;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckCmdReBeg_constructor
        // PR_END
        this.header.packet_id = PckCmdReBeg.ID;
    }

    // PR_BEG PckCmdReBeg_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckCmdReBeg: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckCmdReBeg | null {
        if( packetIdOfArrayBuffer( buffer ) != PckCmdReBeg.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckCmdReBeg();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckCmdPlBeg {

    public static ID = 11;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckCmdPlBeg_constructor
        // PR_END
        this.header.packet_id = PckCmdPlBeg.ID;
    }

    // PR_BEG PckCmdPlBeg_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckCmdPlBeg: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckCmdPlBeg | null {
        if( packetIdOfArrayBuffer( buffer ) != PckCmdPlBeg.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckCmdPlBeg();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckCmdMaBeg {

    public static ID = 13;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckCmdMaBeg_constructor
        // PR_END
        this.header.packet_id = PckCmdMaBeg.ID;
    }

    // PR_BEG PckCmdMaBeg_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckCmdMaBeg: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckCmdMaBeg | null {
        if( packetIdOfArrayBuffer( buffer ) != PckCmdMaBeg.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckCmdMaBeg();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckCmdCalibrate {

    public static ID = 15;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckCmdCalibrate_constructor
        // PR_END
        this.header.packet_id = PckCmdCalibrate.ID;
    }

    // PR_BEG PckCmdCalibrate_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckCmdCalibrate: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckCmdCalibrate | null {
        if( packetIdOfArrayBuffer( buffer ) != PckCmdCalibrate.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckCmdCalibrate();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckCmdTare {

    public static ID = 17;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckCmdTare_constructor
        // PR_END
        this.header.packet_id = PckCmdTare.ID;
    }

    // PR_BEG PckCmdTare_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckCmdTare: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckCmdTare | null {
        if( packetIdOfArrayBuffer( buffer ) != PckCmdTare.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckCmdTare();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckCmdReTrgDPS310 {

    public static ID = 4;
    header: _Ts.Header;
    t_ms: number = 0;
    prs_kPa: number = 0.0;
    tmp_deg_C: number = 0.0;

    constructor() {
        this.header = new _Ts.Header();
        this.t_ms = 0;
        this.prs_kPa = 0.0;
        this.tmp_deg_C = 0.0;
        // PR_BEG PckCmdReTrgDPS310_constructor
        // PR_END
        this.header.packet_id = PckCmdReTrgDPS310.ID;
    }

    // PR_BEG PckCmdReTrgDPS310_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckCmdReTrgDPS310: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 16;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckCmdReTrgDPS310 | null {
        if( packetIdOfArrayBuffer( buffer ) != PckCmdReTrgDPS310.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckCmdReTrgDPS310();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        // t_ms
        if( ! PckCmdReTrgDPS310._check( indexCur + 4, indexEnd) ) {
            throw new RangeError()
        }
        instance.t_ms = dataView.getUint32(indexCur, true);
        indexCur += 4;
        // prs_kPa
        if( ! PckCmdReTrgDPS310._check( indexCur + 4, indexEnd) ) {
            throw new RangeError()
        }
        instance.prs_kPa = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // tmp_deg_C
        if( ! PckCmdReTrgDPS310._check( indexCur + 4, indexEnd) ) {
            throw new RangeError()
        }
        instance.tmp_deg_C = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        // t_ms
        if( ! PckCmdReTrgDPS310._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint32(indexCur, this.t_ms, true);
        indexCur += 4;
        // prs_kPa
        if( ! PckCmdReTrgDPS310._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.prs_kPa, true);
        indexCur += 4;
        // tmp_deg_C
        if( ! PckCmdReTrgDPS310._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.tmp_deg_C, true);
        indexCur += 4;
        return buffer;        
    }
}

export class PckCmdReTrgBNO08X {

    public static ID = 32;
    header: _Ts.Header;
    t_ms: number = 0;
    q_r: number = 0.0;
    q_i: number = 0.0;
    q_j: number = 0.0;
    q_k: number = 0.0;
    acc_u_ms2: number = 0.0;
    acc_v_ms2: number = 0.0;
    acc_w_ms2: number = 0.0;
    omg_u_rads: number = 0.0;
    omg_v_rads: number = 0.0;
    omg_w_rads: number = 0.0;
    mgn: number = 0.0;

    constructor() {
        this.header = new _Ts.Header();
        this.t_ms = 0;
        this.q_r = 0.0;
        this.q_i = 0.0;
        this.q_j = 0.0;
        this.q_k = 0.0;
        this.acc_u_ms2 = 0.0;
        this.acc_v_ms2 = 0.0;
        this.acc_w_ms2 = 0.0;
        this.omg_u_rads = 0.0;
        this.omg_v_rads = 0.0;
        this.omg_w_rads = 0.0;
        this.mgn = 0.0;
        // PR_BEG PckCmdReTrgBNO08X_constructor
        // PR_END
        this.header.packet_id = PckCmdReTrgBNO08X.ID;
    }

    // PR_BEG PckCmdReTrgBNO08X_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckCmdReTrgBNO08X: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 52;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckCmdReTrgBNO08X | null {
        if( packetIdOfArrayBuffer( buffer ) != PckCmdReTrgBNO08X.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckCmdReTrgBNO08X();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        // t_ms
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError()
        }
        instance.t_ms = dataView.getUint32(indexCur, true);
        indexCur += 4;
        // q_r
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError()
        }
        instance.q_r = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // q_i
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError()
        }
        instance.q_i = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // q_j
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError()
        }
        instance.q_j = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // q_k
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError()
        }
        instance.q_k = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // acc_u_ms2
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError()
        }
        instance.acc_u_ms2 = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // acc_v_ms2
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError()
        }
        instance.acc_v_ms2 = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // acc_w_ms2
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError()
        }
        instance.acc_w_ms2 = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // omg_u_rads
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError()
        }
        instance.omg_u_rads = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // omg_v_rads
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError()
        }
        instance.omg_v_rads = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // omg_w_rads
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError()
        }
        instance.omg_w_rads = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // mgn
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError()
        }
        instance.mgn = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        // t_ms
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint32(indexCur, this.t_ms, true);
        indexCur += 4;
        // q_r
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.q_r, true);
        indexCur += 4;
        // q_i
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.q_i, true);
        indexCur += 4;
        // q_j
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.q_j, true);
        indexCur += 4;
        // q_k
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.q_k, true);
        indexCur += 4;
        // acc_u_ms2
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.acc_u_ms2, true);
        indexCur += 4;
        // acc_v_ms2
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.acc_v_ms2, true);
        indexCur += 4;
        // acc_w_ms2
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.acc_w_ms2, true);
        indexCur += 4;
        // omg_u_rads
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.omg_u_rads, true);
        indexCur += 4;
        // omg_v_rads
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.omg_v_rads, true);
        indexCur += 4;
        // omg_w_rads
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.omg_w_rads, true);
        indexCur += 4;
        // mgn
        if( ! PckCmdReTrgBNO08X._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.mgn, true);
        indexCur += 4;
        return buffer;        
    }
}

export class PckCmdReTrg {

    public static ID = 30;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckCmdReTrg_constructor
        // PR_END
        this.header.packet_id = PckCmdReTrg.ID;
    }

    // PR_BEG PckCmdReTrg_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckCmdReTrg: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckCmdReTrg | null {
        if( packetIdOfArrayBuffer( buffer ) != PckCmdReTrg.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckCmdReTrg();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckCmdLog {

    public static ID = 22;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckCmdLog_constructor
        // PR_END
        this.header.packet_id = PckCmdLog.ID;
    }

    // PR_BEG PckCmdLog_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckCmdLog: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckCmdLog | null {
        if( packetIdOfArrayBuffer( buffer ) != PckCmdLog.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckCmdLog();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckCmdInfo {

    public static ID = 23;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckCmdInfo_constructor
        // PR_END
        this.header.packet_id = PckCmdInfo.ID;
    }

    // PR_BEG PckCmdInfo_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckCmdInfo: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckCmdInfo | null {
        if( packetIdOfArrayBuffer( buffer ) != PckCmdInfo.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckCmdInfo();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckCmdReset {

    public static ID = 24;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckCmdReset_constructor
        // PR_END
        this.header.packet_id = PckCmdReset.ID;
    }

    // PR_BEG PckCmdReset_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckCmdReset: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckCmdReset | null {
        if( packetIdOfArrayBuffer( buffer ) != PckCmdReset.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckCmdReset();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckCmdResetBNO08X {

    public static ID = 26;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckCmdResetBNO08X_constructor
        // PR_END
        this.header.packet_id = PckCmdResetBNO08X.ID;
    }

    // PR_BEG PckCmdResetBNO08X_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckCmdResetBNO08X: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckCmdResetBNO08X | null {
        if( packetIdOfArrayBuffer( buffer ) != PckCmdResetBNO08X.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckCmdResetBNO08X();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckCmdResetDPS310 {

    public static ID = 28;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckCmdResetDPS310_constructor
        // PR_END
        this.header.packet_id = PckCmdResetDPS310.ID;
    }

    // PR_BEG PckCmdResetDPS310_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckCmdResetDPS310: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckCmdResetDPS310 | null {
        if( packetIdOfArrayBuffer( buffer ) != PckCmdResetDPS310.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckCmdResetDPS310();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckRspIdBeg {

    public static ID = 8;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckRspIdBeg_constructor
        // PR_END
        this.header.packet_id = PckRspIdBeg.ID;
    }

    // PR_BEG PckRspIdBeg_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckRspIdBeg: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckRspIdBeg | null {
        if( packetIdOfArrayBuffer( buffer ) != PckRspIdBeg.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckRspIdBeg();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckRspReBeg {

    public static ID = 37;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckRspReBeg_constructor
        // PR_END
        this.header.packet_id = PckRspReBeg.ID;
    }

    // PR_BEG PckRspReBeg_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckRspReBeg: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckRspReBeg | null {
        if( packetIdOfArrayBuffer( buffer ) != PckRspReBeg.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckRspReBeg();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckRspPlBeg {

    public static ID = 12;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckRspPlBeg_constructor
        // PR_END
        this.header.packet_id = PckRspPlBeg.ID;
    }

    // PR_BEG PckRspPlBeg_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckRspPlBeg: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckRspPlBeg | null {
        if( packetIdOfArrayBuffer( buffer ) != PckRspPlBeg.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckRspPlBeg();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckRspMaBeg {

    public static ID = 14;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckRspMaBeg_constructor
        // PR_END
        this.header.packet_id = PckRspMaBeg.ID;
    }

    // PR_BEG PckRspMaBeg_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckRspMaBeg: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckRspMaBeg | null {
        if( packetIdOfArrayBuffer( buffer ) != PckRspMaBeg.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckRspMaBeg();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckRspCalibrate {

    public static ID = 16;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckRspCalibrate_constructor
        // PR_END
        this.header.packet_id = PckRspCalibrate.ID;
    }

    // PR_BEG PckRspCalibrate_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckRspCalibrate: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckRspCalibrate | null {
        if( packetIdOfArrayBuffer( buffer ) != PckRspCalibrate.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckRspCalibrate();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckRspTare {

    public static ID = 18;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckRspTare_constructor
        // PR_END
        this.header.packet_id = PckRspTare.ID;
    }

    // PR_BEG PckRspTare_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckRspTare: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckRspTare | null {
        if( packetIdOfArrayBuffer( buffer ) != PckRspTare.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckRspTare();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckRspReTrgDPS310 {

    public static ID = 19;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckRspReTrgDPS310_constructor
        // PR_END
        this.header.packet_id = PckRspReTrgDPS310.ID;
    }

    // PR_BEG PckRspReTrgDPS310_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckRspReTrgDPS310: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckRspReTrgDPS310 | null {
        if( packetIdOfArrayBuffer( buffer ) != PckRspReTrgDPS310.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckRspReTrgDPS310();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckRspReTrgBNO08X {

    public static ID = 33;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckRspReTrgBNO08X_constructor
        // PR_END
        this.header.packet_id = PckRspReTrgBNO08X.ID;
    }

    // PR_BEG PckRspReTrgBNO08X_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckRspReTrgBNO08X: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckRspReTrgBNO08X | null {
        if( packetIdOfArrayBuffer( buffer ) != PckRspReTrgBNO08X.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckRspReTrgBNO08X();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckRspReTrg {

    public static ID = 31;
    header: _Ts.Header;
    samples: Array< _Ts.RecordSample >; // 4

    constructor() {
        this.header = new _Ts.Header();
        this.samples = new Array< _Ts.RecordSample >(); // 4
        this.samples.push( new _Ts.RecordSample() );
        this.samples.push( new _Ts.RecordSample() );
        this.samples.push( new _Ts.RecordSample() );
        this.samples.push( new _Ts.RecordSample() );
        // PR_BEG PckRspReTrg_constructor
        // PR_END
        this.header.packet_id = PckRspReTrg.ID;
    }

    // PR_BEG PckRspReTrg_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckRspReTrg: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 228;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckRspReTrg | null {
        if( packetIdOfArrayBuffer( buffer ) != PckRspReTrg.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckRspReTrg();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        // samples
        let countSamples = 0;
        instance.samples = [];
        while( countSamples < 4 ) {
            const pI: _Ts.RecordSample = _Ts.RecordSample.ofArrayBuffer(buffer, indexCur);
            if( pI !== null ) {
                instance.samples.push( pI );
                indexCur += 56;
                countSamples += 1;
            }
        }
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        // samples
        let countSamples = 0;
        while( countSamples < 4 ) {
            this.samples[ countSamples ].toArrayBuffer(buffer, indexCur);
            indexCur += 56;
            countSamples += 1;
        }
        return buffer;        
    }
}

export class PckRspLog {

    public static ID = 3;
    header: _Ts.Header;
    dongle_state: _Ts.DongleState;
    level: number = 0;
    text: Array< number >; // 217

    constructor() {
        this.header = new _Ts.Header();
        this.dongle_state = new _Ts.DongleState();
        this.level = 0;
        this.text = new Array< number >(); // 217
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        this.text.push( 0 );
        // PR_BEG PckRspLog_constructor
        // PR_END
        this.header.packet_id = PckRspLog.ID;
    }

    // PR_BEG PckRspLog_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckRspLog: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 240;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckRspLog | null {
        if( packetIdOfArrayBuffer( buffer ) != PckRspLog.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckRspLog();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        // dongle_state
        instance.dongle_state = _Ts.DongleState.ofArrayBuffer(buffer, indexCur);
        indexCur += 18;
        // level
        if( ! PckRspLog._check( indexCur + 1, indexEnd) ) {
            throw new RangeError()
        }
        instance.level = dataView.getUint8(indexCur);
        indexCur += 1;
        // text
        if( ! PckRspLog._check( indexCur + 1, indexEnd) ) {
            throw new RangeError()
        }
        let countText = 0;
        instance.text = [];
        while( countText < 217 ) {
            instance.text.push( dataView.getUint8(indexCur) );
            indexCur += 1;
            countText += 1;
        }
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        // dongle_state
        this.dongle_state.toArrayBuffer(buffer, indexCur);
        indexCur += 18;
        // level
        if( ! PckRspLog._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.level);
        indexCur += 1;
        // text
        if( ! PckRspLog._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        let countText = 0;
        while( countText < 217 ) {
            dataView.setUint8(indexCur, this.text[ countText ]);
            indexCur += 1;
            countText += 1;
        }
        return buffer;        
    }
}

export class PckRspInfo {

    public static ID = 6;
    header: _Ts.Header;
    spinnax_freak_version_string: Array< number >; // 32
    spinnax_freak_datetime_string: Array< number >; // 32
    dongle_state: _Ts.DongleState;

    constructor() {
        this.header = new _Ts.Header();
        this.spinnax_freak_version_string = new Array< number >(); // 32
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_version_string.push( 0 );
        this.spinnax_freak_datetime_string = new Array< number >(); // 32
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.spinnax_freak_datetime_string.push( 0 );
        this.dongle_state = new _Ts.DongleState();
        // PR_BEG PckRspInfo_constructor
        // PR_END
        this.header.packet_id = PckRspInfo.ID;
    }

    // PR_BEG PckRspInfo_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckRspInfo: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 86;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckRspInfo | null {
        if( packetIdOfArrayBuffer( buffer ) != PckRspInfo.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckRspInfo();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        // spinnax_freak_version_string
        if( ! PckRspInfo._check( indexCur + 1, indexEnd) ) {
            throw new RangeError()
        }
        let countSpinnax_freak_version_string = 0;
        instance.spinnax_freak_version_string = [];
        while( countSpinnax_freak_version_string < 32 ) {
            instance.spinnax_freak_version_string.push( dataView.getUint8(indexCur) );
            indexCur += 1;
            countSpinnax_freak_version_string += 1;
        }
        // spinnax_freak_datetime_string
        if( ! PckRspInfo._check( indexCur + 1, indexEnd) ) {
            throw new RangeError()
        }
        let countSpinnax_freak_datetime_string = 0;
        instance.spinnax_freak_datetime_string = [];
        while( countSpinnax_freak_datetime_string < 32 ) {
            instance.spinnax_freak_datetime_string.push( dataView.getUint8(indexCur) );
            indexCur += 1;
            countSpinnax_freak_datetime_string += 1;
        }
        // dongle_state
        instance.dongle_state = _Ts.DongleState.ofArrayBuffer(buffer, indexCur);
        indexCur += 18;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        // spinnax_freak_version_string
        if( ! PckRspInfo._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        let countSpinnax_freak_version_string = 0;
        while( countSpinnax_freak_version_string < 32 ) {
            dataView.setUint8(indexCur, this.spinnax_freak_version_string[ countSpinnax_freak_version_string ]);
            indexCur += 1;
            countSpinnax_freak_version_string += 1;
        }
        // spinnax_freak_datetime_string
        if( ! PckRspInfo._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        let countSpinnax_freak_datetime_string = 0;
        while( countSpinnax_freak_datetime_string < 32 ) {
            dataView.setUint8(indexCur, this.spinnax_freak_datetime_string[ countSpinnax_freak_datetime_string ]);
            indexCur += 1;
            countSpinnax_freak_datetime_string += 1;
        }
        // dongle_state
        this.dongle_state.toArrayBuffer(buffer, indexCur);
        indexCur += 18;
        return buffer;        
    }
}

export class PckRspReset {

    public static ID = 25;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckRspReset_constructor
        // PR_END
        this.header.packet_id = PckRspReset.ID;
    }

    // PR_BEG PckRspReset_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckRspReset: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckRspReset | null {
        if( packetIdOfArrayBuffer( buffer ) != PckRspReset.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckRspReset();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckRspResetBNO08X {

    public static ID = 27;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckRspResetBNO08X_constructor
        // PR_END
        this.header.packet_id = PckRspResetBNO08X.ID;
    }

    // PR_BEG PckRspResetBNO08X_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckRspResetBNO08X: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckRspResetBNO08X | null {
        if( packetIdOfArrayBuffer( buffer ) != PckRspResetBNO08X.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckRspResetBNO08X();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}

export class PckRspResetDPS310 {

    public static ID = 29;
    header: _Ts.Header;

    constructor() {
        this.header = new _Ts.Header();
        // PR_BEG PckRspResetDPS310_constructor
        // PR_END
        this.header.packet_id = PckRspResetDPS310.ID;
    }

    // PR_BEG PckRspResetDPS310_user_methods
    // PR_END

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('PckRspResetDPS310: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index = 0): PckRspResetDPS310 | null {
        if( packetIdOfArrayBuffer( buffer ) != PckRspResetDPS310.ID ) {
            return null
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new PckRspResetDPS310();
        // header
        instance.header = _Ts.Header.ofArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer(bufferInput?: ArrayBuffer, index = 0): ArrayBuffer {
        let buffer: ArrayBuffer | undefined = undefined;
        if(bufferInput === undefined) {
            buffer = new ArrayBuffer(_Cs.SIZE_PACKET);
        } else {
            buffer = bufferInput;
        }
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // header
        this.header.toArrayBuffer(buffer, indexCur);
        indexCur += 4;
        return buffer;        
    }
}
